import { useEffect, useRef } from 'react';
export const useCustomCompareEffect = (callback, deps, isEqual) => {
    const currDeps = useRef(null);
    if (!currDeps.current || !isEqual(currDeps.current, deps)) {
        currDeps.current = deps;
    }
    useEffect(callback, currDeps.current);
};
